<mat-toolbar>
    <div class="footer-buttons-container">
        <app-download-zoning-code-import-template [templateType]="templateType"
            style="margin-right: 30px;"></app-download-zoning-code-import-template>
        <zc-validation-icon *ngIf="showValidationIcon" class="zc-validation-icon green"
            style="margin-right: 10px;"></zc-validation-icon>
        <button mat-raised-button color="primary" (click)="uploadFile.emit()">Upload File</button>
        <button mat-raised-button color="primary" (click)="importData.emit()" [disabled]="!canImport">Import</button>
        <button *ngIf="showValidateButton" mat-raised-button (click)="validateZoningCode.emit()">Validate</button>
        <button mat-raised-button (click)="clearTable.emit()">Clear</button>
    </div>
</mat-toolbar>
